var React = require('react');

function User (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M24 3a9.001 9.001 0 109 9 9 9 0 00-9-9zm-12 9c0-6.626 5.374-12 12-12s12 5.374 12 12-5.374 12-12 12-12-5.374-12-12zm12 16.5c-9.942 0-18 8.058-18 18a1.5 1.5 0 01-3 0c0-11.598 9.402-21 21-21s21 9.402 21 21a1.5 1.5 0 01-3 0c0-9.942-8.058-18-18-18z"}));
}

User.defaultProps = {"viewBox":"0 0 48 48"};

module.exports = User;

User.default = User;
